import Carregando from '../components/Carregando';
import { useEffect, useState } from 'react';
import {
  Box, Typography, Card, CardContent, Button,
  Alert, Avatar, Chip,
} from '@mui/material';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import api from '../services/api';
import { iniciarPersonificacao, encerrarPersonificacao, getPersonificandoNome } from '../services/authStorage';

export default function LoginComo() {
  const [usuarios, setUsuarios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState('');

  useEffect(() => {
    api.get('/membros-equipe/').then((res) => {
      setUsuarios(res.data);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  const handleLoginComo = async (userId, nome) => {
    setErro('');
    try {
      const res = await api.post('/auth/login-como/', { user_id: userId });
      iniciarPersonificacao(res.data.access, res.data.refresh, nome);
      window.location.href = '/';
    } catch {
      setErro('Erro ao fazer login como este usuário.');
    }
  };

  const handleVoltarAdmin = () => {
    if (encerrarPersonificacao()) {
      window.location.href = '/login-como';
    }
  };

  const personificando = getPersonificandoNome();

  return (
    <Box>
      <Typography variant="h5" fontWeight={600} mb={1}>
        Login como usuário
      </Typography>
      <Typography variant="body2" color="text.secondary" mb={3}>
        Visualize o sistema como qualquer usuário (só nesta aba)
      </Typography>

      {personificando && (
        <Alert
          severity="warning"
          sx={{ mb: 3 }}
          action={
            <Button color="inherit" size="small" onClick={handleVoltarAdmin}>
              Voltar ao admin
            </Button>
          }
        >
          Você está visualizando o sistema como <strong>{personificando}</strong>
        </Alert>
      )}

      {erro && <Alert severity="error" sx={{ mb: 2 }}>{erro}</Alert>}

      {loading ? (
        <Carregando />
      ) : (
        <Box display="flex" flexDirection="column" gap={2} maxWidth={500}>
          {usuarios.map((c) => (
            <Card key={c.id} sx={{ border: '0.5px solid #e0e0e0' }}>
              <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2, py: 1.5, '&:last-child': { pb: 1.5 } }}>
                <Avatar sx={{ bgcolor: '#1a1a2e' }}>
                  {c.nome_completo?.charAt(0)}
                </Avatar>
                <Box flex={1}>
                  <Typography variant="subtitle2" fontWeight={600}>
                    {c.nome_completo}
                  </Typography>
                  <Box display="flex" gap={1} mt={0.5}>
                    <Chip label={c.perfil} size="small" sx={{ fontSize: 10 }} />
                    <Typography variant="caption" color="text.secondary">
                      {c.email}
                    </Typography>
                  </Box>
                </Box>
                <Button
                  size="small"
                  variant="outlined"
                  startIcon={<SwapHorizIcon />}
                  onClick={() => handleLoginComo(c.usuario.id, c.nome_completo)}
                  sx={{ borderColor: '#1a1a2e', color: '#1a1a2e', flexShrink: 0 }}
                >
                  Entrar como
                </Button>
              </CardContent>
            </Card>
          ))}
        </Box>
      )}
    </Box>
  );
}